import React from 'react'
import { Toaster, Toast, Position } from '@blueprintjs/core'
import { connect } from 'react-redux'

import * as actionTypes from 'src/constants/actionTypes'

import styles from './toastManager.module.scss'

const DEFAULT_TOAST_TIMEOUT = 5000

class CsvImportErrors extends React.Component {
    state = { copied: false }

    render() {
        const { errors } = this.props
        return (
            <div>
                <strong>
                    CSV import failed — {errors.length} error(s) found:
                </strong>
                <ul style={{ margin: '6px 0 8px 0', paddingLeft: '18px' }}>
                    {errors.map((e, i) => (
                        <li key={i}>
                            <strong>Row {e.row}:</strong> {e.message}
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}

class ToastManager extends React.Component {
    renderToast = (message, i) => {
        const content =
            message.errors &&
            Array.isArray(message.errors) &&
            message.errors.length > 0 ? (
                <CsvImportErrors errors={message.errors} />
            ) : (
                message.content
            )

        return (
            <Toast
                key={`${message.content}_${i}`}
                message={content}
                icon={message.icon}
                intent={message.intent}
                timeout={
                    message.timeout !== undefined
                        ? message.timeout
                        : DEFAULT_TOAST_TIMEOUT
                }
                onDismiss={() => {
                    this.props.removeMessageFromState(message)
                }}
            />
        )
    }

    render() {
        let toasts = null
        if (this.props.messages && this.props.messages.length) {
            toasts =
                this.props.messages && this.props.messages.map(this.renderToast)
        }
        return (
            <Toaster className={styles.toaster} position={Position.TOP_RIGHT}>
                {toasts}
            </Toaster>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        messages: state.ui.toast.messages,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        removeMessageFromState: (message) => {
            dispatch({
                type: actionTypes.TOAST_REMOVE,
                message: message,
            })
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToastManager)
